export type Language = 'es' | 'en'

export const translations = {
  es: {
    // Hero
    hero: {
      hook: '"No eres raro. Solo estás más despierto que el promedio."',
      intro1: 'Te lo han dicho más de una vez:',
      intro2:
        '"Piensas demasiado." "Eso son conspiraciones." "Baja de esa nube y ponte serio."',
      intro3:
        'Mientras ellos siguen en modo automático, tú estás en otra frecuencia.',
      intro4:
        'Consumes contenido de Matrix, despertar espiritual, 3-6-9, Tesla, 432 Hz. Guardas hilos sobre manifestación, ves videos de "el sistema te quiere dormido", escuchas audios de frecuencia antes de dormir…',
      intro5: 'Y aun así, te despiertas en la misma realidad de siempre.',
      intro6: 'No es que no entiendas. No es que "te falte fe".',
      intro7:
        'Tu problema no es información. Tu problema es que nadie te dio un manual para usar todo eso que sabes para reprogramar, de verdad, tu vida diaria.',
      title: 'ROMPE LA MATRIX',
      subtitle:
        'Manual práctico para despertar, reprogramarte y crear una nueva realidad fuera de la Matrix',
      cta: 'Descubre Cómo',
    },

    // Double Life Section
    doubleLife: {
      title: 'LA VIDA DOBLE DEL "DESPIERTO A MEDIAS"',
      intro: 'Si eres sincero contigo, tu vida se parece mucho a esto:',
      externalTitle: 'Vida externa (la que todos ven):',
      externalItems: [
        'Estudias, trabajas, cumples.',
        'Respondes WhatsApps, vas, vienes, haces lo que "toca".',
        'Nada grave, nada extremo. Todo "normal".',
      ],
      externalNote:
        'Tu familia podría decir que tu vida está bien. Que "no te falta nada".',
      internalTitle: 'Vida interna (la que casi nadie conoce):',
      internalItems: [
        'Guardas videos de despertar espiritual, Matrix, portales, numerología.',
        'Sigues cuentas que hablan de energía, frecuencia, 432 Hz, 528 Hz.',
        'Tienes pantallazos de frases poderosas, rituales 3-6-9, hilos sobre manifestación.',
        'Sientes cosas extrañas en el cuerpo cuando escuchas ciertas frecuencias o ves ciertos mensajes.',
      ],
      however: 'Y sin embargo…',
      whenClose:
        'Cuando cierras la app, cuando termina el Reel, cuando apagas la pantalla…',
      realityStays: 'Tu realidad externa casi no se mueve.',
      samePatterns:
        'Mismas decisiones. Mismas conversaciones. Mismos miedos. Mismos patrones.',
      hurts:
        'Eso duele. No por drama, sino porque sabes que no viniste a vivir en automático.',
    },

    // Programmed Section
    programmed: {
      title: 'NO ESTÁS ROTO. ESTÁS PROGRAMADO.',
      intro: 'El sistema lleva años diciéndote:',
      systemSays: [
        '"Consigue un trabajo normal y deja de inventar."',
        '"La vida es difícil, así es para todos."',
        '"No se puede tener todo."',
        '"Mejor quédate donde estás, es más seguro."',
      ],
      repeated:
        'Tus padres, tus profesores, los medios, las redes… han repetido la misma frecuencia una y otra vez.',
      becameNormal:
        'Y como todo código que se repite, al final se convierte en tu "normal".',
      programmedForTitle: 'Te programaron para:',
      programmedForItems: [
        'Dudar de ti cuando algo empieza a salir bien.',
        'Sentir culpa si te va mejor que a tu entorno.',
        'Sabotear lo que deseas porque "es demasiado bueno para ser cierto".',
        'Creer que el problema eres tú, porque "no encajas".',
      ],
      truthIs: 'La verdad es otra:',
      notBlocked:
        'No estás bloqueado. Estás programado. Y todo código se puede reescribir.',
    },

    // Need a Map Section
    needMap: {
      title: 'YA NO TE FALTA CONTENIDO. TE FALTA UN MAPA.',
      seenEverything: 'Has visto de todo:',
      seenItems: [
        'Hilos de "cómo manifestar en 24 horas".',
        'Videos de "cómo salir de la Matrix".',
        'Clips de "el gobierno te quiere dormido".',
        'Explicaciones de 3-6-9, 432 Hz, Tesla, portales, líneas de tiempo…',
      ],
      youKnow: 'Lo sabes. Te resuena.',
      butNoOne: 'Pero nadie se ha sentado contigo a decirte:',
      quotes: [
        '"Mira, esta es TU Matrix interna. Aquí está tu programación."',
        '"Este es tu bucle de autosabotaje, así se ve y así se rompe."',
        '"Día 1 haces esto. Día 2, esto. Día 3, esto otro. Hazlo 21 días y observa."',
      ],
      marathons:
        'Has tenido maratones de contenido espiritual, pero cero integración real.',
      knowTooMuch:
        'Sabes demasiado para seguir viviendo como si no supieras nada.',
      needProtocol:
        'Te falta un protocolo. Un plan. Un reto que puedas seguir sin pagar un curso carísimo ni perderte en teoría new age que no aterriza en tu vida diaria.',
      enterHere: 'Ahí entra:',
    },

    // Target Audience
    targetAudience: {
      notPdf:
        'No es un PDF con frases bonitas. No es un "libro de motivación" más.',
      designedFor: 'Es un cuaderno de trabajo diseñado para ti:',
      items: [
        '18–35 años, hombre o mujer.',
        'Ultra conectado a TikTok, Reels, YouTube Shorts.',
        'Que consume contenido de Matrix, 3-6-9, energía, portales, frecuencias…',
        'Que se siente "raro" para su familia y amigos.',
        'Que está cansado de solo ver videos y listo para empezar a reprogramarse de verdad.',
      ],
    },

    // The Mechanism
    mechanism: {
      title:
        'EL MECANISMO QUE NADIE TE EXPLICÓ: TU MATRIX INTERNA + EL CÓDIGO 3-6-9',
      rootProblem: 'La raíz del problema no es que "no puedas manifestar".',
      rootIs:
        'La raíz es que intentas usar herramientas nuevas sobre un sistema operativo viejo.',
      osIs: 'Ese sistema operativo es tu Matrix interna:',
      formula: 'Creencias + emociones + hábitos + entorno.',
      ifNotRewrite:
        'Si no reescribes eso, cualquier ritual se vuelve maquillaje espiritual.',
      showsHow:
        'ROMPE LA MATRIX 3-6-9 te muestra cómo usar el código 3-6-9 no como receta mágica… sino como sistema de reprogramación consciente:',
      three: {
        number: '3',
        title: 'Intención',
        desc: 'Aterrizas con claridad brutal:',
        items: [
          'quién quieres ser,',
          'qué quieres vivir,',
          'desde qué versión de ti estás pidiendo.',
        ],
      },
      six: {
        number: '6',
        title: 'Emoción',
        desc: 'Aprendes a:',
        items: [
          'dejar de pedir desde carencia, miedo y urgencia,',
          'anclar en tu cuerpo la emoción del resultado,',
          'sentir hoy la energía de la realidad que estás creando.',
        ],
      },
      nine: {
        number: '9',
        title: 'Acción',
        desc: 'Rompes tus bucles de autosabotaje con:',
        items: [
          'acciones concretas,',
          'decisiones diferentes,',
          'micro hábitos diarios sostenidos.',
        ],
      },
      stopWriting:
        'Dejas de escribir deseos en un cuaderno para empezar a reescribir el código desde el que decides.',
    },

    // Metaphors
    metaphors: {
      title: '3 METÁFORAS PARA ENTENDER TU PROPIO CAMBIO',
      spotify: {
        title: 'El Spotify de tu realidad',
        desc: 'Es como vivir con una playlist que no elegiste: drama, escasez, miedo. ROMPE LA MATRIX 3-6-9 es entrar a tu Spotify interno y cambiar no solo la canción… sino la playlist completa con la que piensas, sientes y actúas.',
      },
      glitch: {
        title: 'El glitch consciente',
        desc: 'Has visto videos de glitches en la Matrix. Este manual convierte ese glitch en algo interno: un corte en el patrón donde dices "hasta aquí llego con esta versión de mí" y empiezas a operar con otro código.',
      },
      player: {
        title: 'El manual del jugador, no del NPC',
        desc: 'Si todo el mundo juega el mismo juego pero tú ves que algo no cuadra, no eres un NPC. ROMPE LA MATRIX 3-6-9 es el manual del jugador que ya sabe que el juego existe… y ahora quiere aprender a usar los controles.',
      },
    },

    // What's Inside
    whatsInside: {
      title: '¿QUÉ HAY DENTRO DE ROMPE LA MATRIX 3-6-9?',
      radiography: {
        title: 'Radiografía de tu Matrix interna',
        intro: 'Antes de reprogramar, tienes que ver el código.',
        desc: 'Con ejemplos claros y lenguaje que entiendes, verás:',
        items: [
          'Cómo la Matrix mental, social y digital te ha formado por dentro.',
          'Por qué piensas lo que piensas sobre dinero, amor, éxito, vida.',
          'Cómo se construyó tu diálogo interno sin que tú lo eligieras.',
          'Por qué, aunque sepas más, sigues eligiendo lo mismo.',
        ],
        note: 'No es para que te culpes. Es para que, por primera vez, veas el mapa completo.',
      },
      deprogramming: {
        title: 'Desprogramación: ver el código que repites',
        desc: 'A través de preguntas incómodas y ejercicios escribibles, vas a trabajar:',
        items: [
          'Creencias heredadas sobre escasez, culpa, merecimiento.',
          'Lealtades invisibles con tu familia ("si a mí me va bien, los traiciono").',
          'Patrones que se repiten en tus relaciones y decisiones.',
          'Formas específicas en las que tú mismo te saboteas.',
        ],
        note: 'Pasas de ser consumidor pasivo de contenido a observador consciente de tu propia Matrix.',
      },
      code369: {
        title: 'El código 3-6-9 aplicado a tu vida real',
        intro: 'Nada de ritual random visto en TikTok sin contexto.',
        desc: 'Aquí verás el 3-6-9 desmenuzado y aterrizado a tu día a día:',
        items: [
          'Cómo definir una intención que no sea un simple "quiero más dinero".',
          'Cómo conectar emoción + cuerpo + decisión, no solo pensamiento.',
          'Cómo usar micro acciones (llamadas, mensajes, cambios en hábitos) para moverte de tu vieja línea de tiempo a una nueva.',
        ],
        note: 'Dejas de tratar el 3-6-9 como magia, y empiezas a usarlo como protocolo de reprogramación.',
      },
      capsule: {
        title: 'Tu cápsula 3-6-9 de alta frecuencia',
        desc: 'Diseñarás tu propia "cápsula":',
        items: [
          'Pensamientos que sostienen tu nueva identidad.',
          'Emociones que ya no vienen del miedo, sino de expansión.',
          'Acciones pequeñas pero coherentes con quien dices que eres.',
        ],
        note: 'No es algo que leas una vez y ya. Es un sistema que puedes volver a activar cada vez que sientas que te estás volviendo a dormir.',
      },
      challenge: {
        title: 'Reto ROMPE LA MATRIX 3-6-9 de 21 días',
        gameChanger: 'Aquí está la parte que cambia el juego.',
        desc: 'Un reto de 21 días con instrucciones simples y claras:',
        items: [
          'Día 1: ver, escribir y confrontar cierta parte de tu programación.',
          'Día 2: redefinir un aspecto clave de tu identidad.',
          'Día 3: una acción pequeña que antes evitabas.',
          '… y así sucesivamente.',
        ],
        notImpossible:
          'No son tareas imposibles. Son pasos pequeños, pero alineados.',
        sameLogic: 'Usas la misma lógica con la que la Matrix te programó:',
        formula: 'Repetición + emoción + entorno.',
        inYourFavor: 'Solo que ahora lo haces a tu favor.',
      },
      midCta: 'QUIERO ROMPER MI MATRIX',
    },

    // After 21 Days
    after21: {
      title: '¿QUÉ PASA DESPUÉS DE 21 DÍAS?',
      noPromise:
        'No te voy a prometer que vas a manifestar un millón en la cuenta ni que vas a salir flotando por la pieza.',
      promiseReal: 'Te prometo algo mucho más valioso (y real):',
      items: [
        'Dejas de sentirte el "raro" del grupo… y empiezas a verte como el adelantado.',
        'Dejas de vivir con la frase "siento que no encajo en esta realidad" y empiezas a decir: "estoy creando una realidad que sí encaja conmigo".',
        'Empiezas a notar: decisiones que antes postergabas, ahora las tomas; relaciones que ya no resuenan, las sueltas; oportunidades que siempre estuvieron ahí, ahora las ves.',
      ],
      notBecause:
        'No porque el mundo cambie de golpe. Porque cambias tú, el que observa el mundo.',
    },

    // For You If
    forYou: {
      title: 'ESTE MANUAL ES PARA TI SI…',
      items: [
        'Tu familia y amigos piensan que exageras con "esos temas".',
        'Sientes que ves algo que los demás no ven.',
        'Te identificas con frases como "siento que no encajo en esta realidad".',
        'Tienes carpetas llenas de videos de despertar, pero tu vida aún no refleja ese despertar.',
        'No quieres (o no puedes) pagar un curso caro, pero sí estás listo para seguir un método real.',
        'Estás dispuesto a escribir, mirarte, confrontarte y actuar distinto.',
      ],
    },

    // Not For You
    notForYou: {
      title: 'NO ES PARA TI SI…',
      items: [
        'Solo quieres un ritual express para seguir haciendo exactamente lo mismo.',
        'Prefieres culpar al sistema, pero sin cambiar tus decisiones.',
        'No estás dispuesto a comprometerte con 21 días seguidos.',
      ],
    },

    // Does It Work
    doesItWork: {
      title: '"¿PERO DE VERDAD FUNCIONA?"',
      realQuestion: 'La pregunta real es:',
      areYouWilling:
        '"¿Estoy dispuesto a aplicar algo con conciencia durante 21 días seguidos?"',
      notMagic:
        'ROMPE LA MATRIX 3-6-9 no es una varita mágica. Es un protocolo.',
      worksIf: 'Funciona si tú funcionas.',
      ifYou:
        'Si lees. Si escribes. Si haces las acciones. Si dejas de tratar tu despertar como entretenimiento y lo tratas como una decisión de vida.',
      guarantee: 'Lo que sí puedo garantizarte es:',
      guaranteeItems: [
        'Una claridad que antes no tenías.',
        'Preguntas que nadie te había hecho.',
        'Estructura donde antes solo había videos sueltos.',
        'Un mapa que puedes volver a usar cada vez que sientas que te estás perdiendo.',
      ],
    },

    // What You Receive
    whatYouReceive: {
      title: '¿QUÉ RECIBES EXACTAMENTE?',
      when: 'Cuando descargas ROMPE LA MATRIX 3-6-9 obtienes:',
      items: [
        {
          emoji: '📘',
          title: 'E-book / cuaderno de trabajo ROMPE LA MATRIX 3-6-9',
          desc: 'en formato digital, descargable.',
        },
        {
          emoji: '🔓',
          title: 'Ejercicios de desprogramación',
          desc: 'Preguntas profundas y hojas de trabajo para escribir, reflexionar y ver tu código.',
        },
        {
          emoji: '💊',
          title: 'Diseño de tu cápsula 3-6-9',
          desc: 'Tu propio sistema de alta frecuencia personalizado.',
        },
        {
          emoji: '📅',
          title: 'Reto de 21 días',
          desc: 'Calendario con acciones claras, simples y accionables para integrar todo.',
        },
      ],
      accessible:
        'Todo en un formato accesible, pensado para que puedas empezar HOY, sin pagar cientos de dólares por un curso que luego ni terminas.',
    },

    // Imagine
    imagine: {
      title: 'IMAGINA TU VIDA 21 DÍAS DESPUÉS…',
      same: 'Misma ciudad. Misma familia. Mismo mundo.',
      butYou: 'Pero tú:',
      items: [
        'Ya no tragas contenido espiritual con ansiedad. Lo filtras con criterio y lo integras.',
        'Ya no sientes que estás "mal puesto" en esta realidad. Sabes que no viniste a encajar: viniste a crear.',
        'Tu diálogo interno deja de ser tu peor enemigo y empieza a ser tu principal aliado.',
        'Empiezas a sentir algo nuevo: coherencia entre lo que sabes, lo que sientes y lo que haces.',
      ],
      notMotivation: 'No es motivación. Es reprogramación.',
    },

    // Final CTA
    finalCta: {
      title: 'TU LÍNEA DE TIEMPO CAMBIA CUANDO TÚ CAMBIAS',
      moment:
        'Hay un momento en el que ya no puedes hacerte el dormido. Si has llegado hasta aquí, ese momento es hoy.',
      twoOptions: 'Tienes dos opciones:',
      option1:
        'Cerrar esta página y seguir scrolleando videos de despertar mientras tu vida sigue igual.',
      option2:
        'O decir: "Basta de solo consumir. Es hora de reescribir mi código."',
      ifSecond: 'Si eliges la segunda:',
      steps: [
        'Haz clic en el botón.',
        'Completa tu compra.',
        'Descarga ROMPE LA MATRIX 3-6-9.',
        'Marca tu Día 1 del reto de 21 días.',
      ],
      everyPage:
        'Cada página que llenes, cada ejercicio que completes, cada acción consciente que tomes,',
      clearMessage: 'será un mensaje claro al sistema:',
      quote: '"Ya no juego como NPC. Yo soy el Creador."',
      notWhat: 'No eres lo que la Matrix hizo de ti.',
      youAre: 'Eres lo que decides crear a partir de hoy.',
      cta: 'DESCARGAR ROMPE LA MATRIX 3-6-9',
      access: 'Acceso inmediato • Formato digital • Comienza hoy',
    },

    // Footer
    footer: {
      rights: 'Todos los derechos reservados.',
    },

    // CTA Button
    ctaButton: {
      packageValue: 'Valor total del paquete:',
      savings: 'Ahorras',
      securePayment: 'Pago seguro',
      instantAccess: 'Acceso inmediato',
    },

    // Pricing Section
    pricing: {
      title: 'OBTÉN ACCESO COMPLETO HOY',
      subtitle: 'Todo lo que necesitas para romper tu Matrix interna',
      price: '$7.97',
      originalPrice: '$47',
      discount: 'Precio de lanzamiento',
      cta: 'DESCARGAR AHORA',
      guarantee: 'Acceso inmediato • Formato digital • Comienza hoy',
      includes: 'Incluye:',
      features: [
        'E-book completo ROMPE LA MATRIX 3-6-9',
        'Ejercicios de desprogramación',
        'Diseño de tu cápsula 3-6-9',
        'Reto de 21 días con calendario',
        'Acceso de por vida',
        'Actualizaciones gratuitas',
      ],
      bonus: {
        badge: 'BONO 1',
        title: 'DESPERTAR DMT: LA CHISPA QUE TE SACA DE LA MATRIX',
        includes: 'Incluye:',
        features: [
          'Mini-guía "Despertar DMT – La molécula del despertar interna"',
          'Explicación simple del mito de la "molécula de Dios" y cómo usarla como metáfora de tu propio glitch de conciencia',
          'Ritual guiado de 5–10 minutos con respiración 3-6-9 para "glitchear" tu Matrix interna',
          'Protocolo para activar tu visión DMT y ver el código detrás de tus miedos, patrones y decisiones',
          'Hoja de trabajo 3-6-9 imprimible para bajar insights y diseñar 9 micro-acciones',
          'Guía para integrar el Ritual DMT dentro del método ROMPE LA MATRIX 3-6-9',
        ],
      },
      bonus2: {
        badge: 'BONUS 2',
        title: 'PROTOCOLO SAL DE LA MATRIX EN 7 CAPAS',
        subtitle:
          'Mini-guía práctica para dejar de vivir en automático y empezar a actuar como Creador consciente, capa por capa.',
        includes: 'Incluye:',
        features: [
          'Mapa completo de las 7 capas de Matrix personal (mental, emocional, física, social, digital, tiempo, identidad)',
          'Test diagnóstico "¿En qué capa estás dormido?" para descubrir tu eslabón más débil en 5-10 minutos',
          '7 micro-acciones GLITCH (una por capa): reescritura 3-6-9, ritual emocional, cambio de hábito, límites conscientes, limpieza digital, bloque intocable, decisión de identidad',
          'Guía simple, directa y fácil de aplicar con pasos concretos para cortar tu Matrix interna desde hoy',
        ],
        benefitLabel: 'Beneficio directo:',
        benefit:
          'Dejas de "entender la Matrix" solo en tu cabeza y empiezas a salir de ella en tu vida diaria, con cambios visibles en tu mente, energía, hábitos y decisiones.',
      },
      bonus3: {
        badge: 'BONUS 3',
        title: 'CÓMO EXPLICAR TU DESPERTAR SIN PARECER LOCO',
        value: 'Valor: $27 USD',
        subtitle:
          'Guía práctica para hablar de la Matrix, tu energía y tu proceso interno… sin perder relaciones importantes ni sentir culpa por cambiar.',
        includes: 'Incluye:',
        features: [
          'Por qué tu despertar incomoda a otros: Entiende la raíz del rechazo, burla e incomprensión cuando empiezas a despertar',
          'Frases puente para explicar tu proceso sin sonar fanático: Scripts claros para hablar con familia, pareja, amigos y compañeros de trabajo',
          'Mini-ritual de 3 pasos antes de conversaciones difíciles: Cómo regular tu energía para comunicar desde la calma y no desde la necesidad',
          'Scripts de límites sanos cuando se burlan o invalidan: Respuestas firmes sin drama para proteger tu proceso sin romper vínculos',
          'Cómo mantener tus relaciones sin traicionarte: Diferencia entre círculo interno, medio y externo; a quién contarle qué',
          'Plan de 7 días para comunicar tu despertar con fuerza tranquila: Acciones diarias para dejar de esconder tu proceso',
        ],
        benefitLabel: 'Beneficio directo:',
        benefit:
          'Aprendes a explicar tu despertar sin miedo, sin conflicto y sin sentirte "el raro", mientras proteges tus relaciones y tu paz interna.',
      },
      trustBadges: {
        secure: 'Secure payment',
        instant: 'Instant access',
      },
    },
  },

  en: {
    // Hero
    hero: {
      hook: '"You\'re not weird. You\'re just more awake than average."',
      intro1: "They've told you more than once:",
      intro2:
        '"You think too much." "That\'s conspiracy stuff." "Get off that cloud and be serious."',
      intro3:
        "While they keep running on autopilot, you're on a different frequency.",
      intro4:
        'You consume Matrix content, spiritual awakening, 3-6-9, Tesla, 432 Hz. You save threads about manifestation, watch videos about "the system wants you asleep," listen to frequency audios before bed…',
      intro5: 'And yet, you wake up to the same reality as always.',
      intro6:
        "It's not that you don't understand. It's not that you \"lack faith.\"",
      intro7:
        "Your problem isn't information. Your problem is that nobody gave you a manual to use everything you know to actually reprogram your daily life.",
      title: 'BREAK THE MATRIX',
      subtitle:
        'Practical manual to awaken, reprogram yourself, and create a new reality outside the Matrix',
      cta: 'Discover How',
    },

    // Double Life Section
    doubleLife: {
      title: 'THE DOUBLE LIFE OF THE "HALF-AWAKE"',
      intro: "If you're honest with yourself, your life looks a lot like this:",
      externalTitle: 'External life (what everyone sees):',
      externalItems: [
        'You study, work, comply.',
        'You answer WhatsApps, come and go, do what you\'re "supposed to."',
        'Nothing serious, nothing extreme. Everything "normal."',
      ],
      externalNote:
        'Your family could say your life is fine. That "you\'re not missing anything."',
      internalTitle: 'Internal life (what almost nobody knows):',
      internalItems: [
        'You save videos about spiritual awakening, Matrix, portals, numerology.',
        'You follow accounts that talk about energy, frequency, 432 Hz, 528 Hz.',
        'You have screenshots of powerful phrases, 3-6-9 rituals, threads about manifestation.',
        'You feel strange things in your body when you hear certain frequencies or see certain messages.',
      ],
      however: 'And yet…',
      whenClose:
        'When you close the app, when the Reel ends, when you turn off the screen…',
      realityStays: 'Your external reality barely moves.',
      samePatterns:
        'Same decisions. Same conversations. Same fears. Same patterns.',
      hurts:
        "That hurts. Not for drama, but because you know you didn't come here to live on autopilot.",
    },

    // Programmed Section
    programmed: {
      title: "YOU'RE NOT BROKEN. YOU'RE PROGRAMMED.",
      intro: 'The system has been telling you for years:',
      systemSays: [
        '"Get a normal job and stop making things up."',
        '"Life is hard, that\'s how it is for everyone."',
        '"You can\'t have everything."',
        '"Better stay where you are, it\'s safer."',
      ],
      repeated:
        'Your parents, your teachers, the media, social networks… have repeated the same frequency over and over.',
      becameNormal:
        'And like any code that repeats, it eventually becomes your "normal."',
      programmedForTitle: 'You were programmed to:',
      programmedForItems: [
        'Doubt yourself when something starts going well.',
        'Feel guilty if you do better than your environment.',
        'Sabotage what you desire because "it\'s too good to be true."',
        'Believe the problem is you, because "you don\'t fit in."',
      ],
      truthIs: 'The truth is different:',
      notBlocked:
        "You're not blocked. You're programmed. And all code can be rewritten.",
    },

    // Need a Map Section
    needMap: {
      title: "YOU DON'T LACK CONTENT. YOU LACK A MAP.",
      seenEverything: "You've seen everything:",
      seenItems: [
        'Threads about "how to manifest in 24 hours."',
        'Videos about "how to exit the Matrix."',
        'Clips about "the government wants you asleep."',
        'Explanations of 3-6-9, 432 Hz, Tesla, portals, timelines…',
      ],
      youKnow: 'You know it. It resonates with you.',
      butNoOne: 'But nobody has sat down with you to say:',
      quotes: [
        '"Look, this is YOUR internal Matrix. Here\'s your programming."',
        '"This is your self-sabotage loop, this is what it looks like and how to break it."',
        '"Day 1 you do this. Day 2, this. Day 3, this. Do it for 21 days and observe."',
      ],
      marathons:
        "You've had marathons of spiritual content, but zero real integration.",
      knowTooMuch: 'You know too much to keep living as if you knew nothing.',
      needProtocol:
        "You need a protocol. A plan. A challenge you can follow without paying for an expensive course or getting lost in new age theory that doesn't land in your daily life.",
      enterHere: "That's where this comes in:",
    },

    // Target Audience
    targetAudience: {
      notPdf:
        'It\'s not a PDF with pretty phrases. It\'s not another "motivation book."',
      designedFor: "It's a workbook designed for you:",
      items: [
        '18–35 years old, man or woman.',
        'Ultra connected to TikTok, Reels, YouTube Shorts.',
        'Who consumes Matrix content, 3-6-9, energy, portals, frequencies…',
        'Who feels "weird" to their family and friends.',
        'Who is tired of just watching videos and ready to start reprogramming for real.',
      ],
    },

    // The Mechanism
    mechanism: {
      title:
        'THE MECHANISM NOBODY EXPLAINED: YOUR INTERNAL MATRIX + THE 3-6-9 CODE',
      rootProblem: 'The root of the problem isn\'t that "you can\'t manifest."',
      rootIs:
        "The root is that you're trying to use new tools on an old operating system.",
      osIs: 'That operating system is your internal Matrix:',
      formula: 'Beliefs + emotions + habits + environment.',
      ifNotRewrite:
        "If you don't rewrite that, any ritual becomes spiritual makeup.",
      showsHow:
        'BREAK THE MATRIX 3-6-9 shows you how to use the 3-6-9 code not as a magic recipe… but as a conscious reprogramming system:',
      three: {
        number: '3',
        title: 'Intention',
        desc: 'You land with brutal clarity:',
        items: [
          'who you want to be,',
          'what you want to experience,',
          "from which version of yourself you're asking.",
        ],
      },
      six: {
        number: '6',
        title: 'Emotion',
        desc: 'You learn to:',
        items: [
          'stop asking from scarcity, fear, and urgency,',
          'anchor the emotion of the result in your body,',
          "feel today the energy of the reality you're creating.",
        ],
      },
      nine: {
        number: '9',
        title: 'Action',
        desc: 'You break your self-sabotage loops with:',
        items: [
          'concrete actions,',
          'different decisions,',
          'sustained daily micro habits.',
        ],
      },
      stopWriting:
        'You stop writing wishes in a notebook and start rewriting the code from which you decide.',
    },

    // Metaphors
    metaphors: {
      title: '3 METAPHORS TO UNDERSTAND YOUR OWN CHANGE',
      spotify: {
        title: 'The Spotify of your reality',
        desc: "It's like living with a playlist you didn't choose: drama, scarcity, fear. BREAK THE MATRIX 3-6-9 is entering your internal Spotify and changing not just the song… but the entire playlist with which you think, feel, and act.",
      },
      glitch: {
        title: 'The conscious glitch',
        desc: 'You\'ve seen videos of glitches in the Matrix. This manual turns that glitch into something internal: a cut in the pattern where you say "this is as far as I go with this version of me" and start operating with different code.',
      },
      player: {
        title: "The player's manual, not the NPC's",
        desc: "If everyone plays the same game but you see something doesn't add up, you're not an NPC. BREAK THE MATRIX 3-6-9 is the player's manual who already knows the game exists… and now wants to learn to use the controls.",
      },
    },

    // What's Inside
    whatsInside: {
      title: "WHAT'S INSIDE BREAK THE MATRIX 3-6-9?",
      radiography: {
        title: 'X-ray of your internal Matrix',
        intro: 'Before reprogramming, you have to see the code.',
        desc: "With clear examples and language you understand, you'll see:",
        items: [
          'How the mental, social, and digital Matrix has shaped you from within.',
          'Why you think what you think about money, love, success, life.',
          'How your internal dialogue was built without you choosing it.',
          'Why, even though you know more, you keep choosing the same.',
        ],
        note: "It's not for you to blame yourself. It's so that, for the first time, you see the complete map.",
      },
      deprogramming: {
        title: 'Deprogramming: seeing the code you repeat',
        desc: "Through uncomfortable questions and writable exercises, you'll work on:",
        items: [
          'Inherited beliefs about scarcity, guilt, deserving.',
          'Invisible loyalties to your family ("if I do well, I betray them").',
          'Patterns that repeat in your relationships and decisions.',
          'Specific ways in which you sabotage yourself.',
        ],
        note: 'You go from being a passive content consumer to a conscious observer of your own Matrix.',
      },
      code369: {
        title: 'The 3-6-9 code applied to your real life',
        intro: 'No random ritual seen on TikTok without context.',
        desc: "Here you'll see 3-6-9 broken down and grounded in your daily life:",
        items: [
          'How to define an intention that isn\'t just "I want more money."',
          'How to connect emotion + body + decision, not just thought.',
          'How to use micro actions (calls, messages, habit changes) to move from your old timeline to a new one.',
        ],
        note: 'You stop treating 3-6-9 as magic and start using it as a reprogramming protocol.',
      },
      capsule: {
        title: 'Your high-frequency 3-6-9 capsule',
        desc: 'You\'ll design your own "capsule":',
        items: [
          'Thoughts that sustain your new identity.',
          'Emotions that no longer come from fear, but from expansion.',
          'Small actions but coherent with who you say you are.',
        ],
        note: "It's not something you read once and done. It's a system you can reactivate every time you feel you're falling asleep again.",
      },
      challenge: {
        title: 'BREAK THE MATRIX 3-6-9 21-day Challenge',
        gameChanger: "Here's the part that changes the game.",
        desc: 'A 21-day challenge with simple and clear instructions:',
        items: [
          'Day 1: see, write, and confront a certain part of your programming.',
          'Day 2: redefine a key aspect of your identity.',
          'Day 3: a small action you used to avoid.',
          '… and so on.',
        ],
        notImpossible:
          "They're not impossible tasks. They're small steps, but aligned.",
        sameLogic:
          'You use the same logic with which the Matrix programmed you:',
        formula: 'Repetition + emotion + environment.',
        inYourFavor: 'Only now you do it in your favor.',
      },
      midCta: 'I WANT TO BREAK MY MATRIX',
    },

    // After 21 Days
    after21: {
      title: 'WHAT HAPPENS AFTER 21 DAYS?',
      noPromise:
        "I'm not going to promise you'll manifest a million in your account or float out of your room.",
      promiseReal: 'I promise you something much more valuable (and real):',
      items: [
        'You stop feeling like the "weird one" in the group… and start seeing yourself as the one ahead.',
        'You stop living with the phrase "I feel like I don\'t fit in this reality" and start saying: "I\'m creating a reality that fits me."',
        'You start noticing: decisions you used to postpone, now you make them; relationships that no longer resonate, you let them go; opportunities that were always there, now you see them.',
      ],
      notBecause:
        'Not because the world changes suddenly. Because you change, the one who observes the world.',
    },

    // For You If
    forYou: {
      title: 'THIS MANUAL IS FOR YOU IF…',
      items: [
        'Your family and friends think you exaggerate with "those topics."',
        "You feel like you see something others don't see.",
        'You identify with phrases like "I feel like I don\'t fit in this reality."',
        "You have folders full of awakening videos, but your life doesn't yet reflect that awakening.",
        "You don't want (or can't) pay for an expensive course, but you're ready to follow a real method.",
        "You're willing to write, look at yourself, confront yourself, and act differently.",
      ],
    },

    // Not For You
    notForYou: {
      title: "IT'S NOT FOR YOU IF…",
      items: [
        'You just want an express ritual to keep doing exactly the same.',
        'You prefer to blame the system, but without changing your decisions.',
        "You're not willing to commit to 21 consecutive days.",
      ],
    },

    // Does It Work
    doesItWork: {
      title: '"BUT DOES IT REALLY WORK?"',
      realQuestion: 'The real question is:',
      areYouWilling:
        '"Am I willing to apply something consciously for 21 consecutive days?"',
      notMagic: "BREAK THE MATRIX 3-6-9 is not a magic wand. It's a protocol.",
      worksIf: 'It works if you work.',
      ifYou:
        'If you read. If you write. If you do the actions. If you stop treating your awakening as entertainment and treat it as a life decision.',
      guarantee: 'What I can guarantee you is:',
      guaranteeItems: [
        "A clarity you didn't have before.",
        'Questions nobody had asked you.',
        'Structure where before there were only scattered videos.',
        "A map you can use again every time you feel you're getting lost.",
      ],
    },

    // What You Receive
    whatYouReceive: {
      title: 'WHAT DO YOU RECEIVE EXACTLY?',
      when: 'When you download BREAK THE MATRIX 3-6-9 you get:',
      items: [
        {
          emoji: '📘',
          title: 'E-book / BREAK THE MATRIX 3-6-9 workbook',
          desc: 'in digital format, downloadable.',
        },
        {
          emoji: '🔓',
          title: 'Deprogramming exercises',
          desc: 'Deep questions and worksheets to write, reflect, and see your code.',
        },
        {
          emoji: '💊',
          title: 'Design of your 3-6-9 capsule',
          desc: 'Your own personalized high-frequency system.',
        },
        {
          emoji: '📅',
          title: '21-day challenge',
          desc: 'Calendar with clear, simple, and actionable steps to integrate everything.',
        },
      ],
      accessible:
        'All in an accessible format, designed so you can start TODAY, without paying hundreds of dollars for a course you never finish.',
    },

    // Imagine
    imagine: {
      title: 'IMAGINE YOUR LIFE 21 DAYS LATER…',
      same: 'Same city. Same family. Same world.',
      butYou: 'But you:',
      items: [
        'You no longer consume spiritual content with anxiety. You filter it with criteria and integrate it.',
        'You no longer feel "out of place" in this reality. You know you didn\'t come to fit in: you came to create.',
        'Your internal dialogue stops being your worst enemy and starts being your main ally.',
        'You start feeling something new: coherence between what you know, what you feel, and what you do.',
      ],
      notMotivation: "It's not motivation. It's reprogramming.",
    },

    // Final CTA
    finalCta: {
      title: 'YOUR TIMELINE CHANGES WHEN YOU CHANGE',
      moment:
        "There's a moment when you can no longer pretend to be asleep. If you've made it this far, that moment is today.",
      twoOptions: 'You have two options:',
      option1:
        'Close this page and keep scrolling awakening videos while your life stays the same.',
      option2:
        'Or say: "Enough of just consuming. It\'s time to rewrite my code."',
      ifSecond: 'If you choose the second:',
      steps: [
        'Click the button.',
        'Complete your purchase.',
        'Download BREAK THE MATRIX 3-6-9.',
        'Mark your Day 1 of the 21-day challenge.',
      ],
      everyPage:
        'Every page you fill, every exercise you complete, every conscious action you take,',
      clearMessage: 'will be a clear message to the system:',
      quote: '"I no longer play as an NPC. I am the Creator."',
      notWhat: 'You are not what the Matrix made of you.',
      youAre: 'You are what you decide to create from today.',
      cta: 'DOWNLOAD BREAK THE MATRIX 3-6-9',
      access: 'Immediate access • Digital format • Start today',
    },

    // Footer
    footer: {
      rights: 'All rights reserved.',
    },

    // CTA Button
    ctaButton: {
      packageValue: 'Total package value:',
      savings: 'You save',
      securePayment: 'Secure payment',
      instantAccess: 'Instant access',
    },

    // Pricing Section
    pricing: {
      title: 'GET FULL ACCESS TODAY',
      subtitle: 'Everything you need to break your internal Matrix',
      price: '$7.97',
      originalPrice: '$47',
      discount: 'Launch price',
      cta: 'DOWNLOAD NOW',
      guarantee: 'Immediate access • Digital format • Start today',
      includes: 'Includes:',
      features: [
        'Complete BREAK THE MATRIX 3-6-9 e-book',
        'Deprogramming exercises',
        'Design of your 3-6-9 capsule',
        '21-day challenge with calendar',
        'Lifetime access',
        'Free updates',
      ],
      bonus: {
        badge: 'BONUS 1',
        title: 'DESPERTAR DMT: LA CHISPA QUE TE SACA DE LA MATRIX',
        includes: 'Includes:',
        features: [
          'Mini-guía "Despertar DMT – La molécula del despertar interna"',
          'Explicación simple del mito de la "molécula de Dios" y cómo usarla como metáfora de tu propio glitch de conciencia',
          'Ritual guiado de 5–10 minutos con respiración 3-6-9 para "glitchear" tu Matrix interna',
          'Protocolo para activar tu visión DMT y ver el código detrás de tus miedos, patrones y decisiones',
          'Hoja de trabajo 3-6-9 imprimible para bajar insights y diseñar 9 micro-acciones',
          'Guía para integrar el Ritual DMT dentro del método ROMPE LA MATRIX 3-6-9',
        ],
      },
      bonus2: {
        badge: 'BONUS 2',
        title: 'EXIT THE MATRIX PROTOCOL IN 7 LAYERS',
        subtitle:
          'Practical mini-guide to stop living on autopilot and start acting as a conscious Creator, layer by layer.',
        includes: 'Includes:',
        features: [
          'Complete map of the 7 layers of personal Matrix (mental, emotional, physical, social, digital, time, identity)',
          'Diagnostic test "Which layer are you asleep in?" to discover your weakest link in 5-10 minutes',
          '7 GLITCH micro-actions (one per layer): 3-6-9 rewriting, emotional ritual, habit change, conscious boundaries, digital cleanse, untouchable block, identity decision',
          'Simple, direct and easy-to-apply guide with concrete steps to cut your internal Matrix starting today',
        ],
        benefitLabel: 'Direct benefit:',
        benefit:
          'You stop "understanding the Matrix" only in your head and start exiting it in your daily life, with visible changes in your mind, energy, habits and decisions.',
      },
      bonus3: {
        badge: 'BONUS 3',
        title: 'HOW TO EXPLAIN YOUR AWAKENING WITHOUT SEEMING CRAZY',
        value: 'Value: $27 USD',
        subtitle:
          'Practical guide to talk about the Matrix, your energy and your internal process… without losing important relationships or feeling guilty about changing.',
        includes: 'Includes:',
        features: [
          'Why your awakening makes others uncomfortable: Understand the root of rejection, mockery and misunderstanding when you start awakening',
          'Bridge phrases to explain your process without sounding fanatical: Clear scripts to talk with family, partner, friends and coworkers',
          '3-step mini-ritual before difficult conversations: How to regulate your energy to communicate from calm and not from need',
          'Healthy boundary scripts when they mock or invalidate: Firm responses without drama to protect your process without breaking bonds',
          'How to maintain your relationships without betraying yourself: Difference between inner, middle and outer circle; who to tell what',
          '7-day plan to communicate your awakening with quiet strength: Daily actions to stop hiding your process',
        ],
        benefitLabel: 'Direct benefit:',
        benefit:
          'You learn to explain your awakening without fear, without conflict and without feeling like "the weird one", while protecting your relationships and inner peace.',
      },
      trustBadges: {
        secure: 'Secure payment',
        instant: 'Instant access',
      },
    },
  },
}
